import { BlockMetas } from "@page-js/Pages/Page/Editor/scripts/blockMeta";
import BlockEditor from "@/editor/blockEditor";
import BlockFactory from "@/editor/blockFactory";
import { EditorOptions } from "@/editor/types";

export default class PageBlockEditor extends BlockEditor {
  constructor(json: any = null, opts: EditorOptions = {} as any) {
    super(json, opts);

    this._props = Object.assign({}, this.init()?.props ?? {}, json?.props ?? {});
    this._attrs = Object.assign({}, this.init()?.attrs ?? {}, json?.attrs ?? {});
  }

  private _props: Record<string, any>;
  private _attrs: Record<string, any>;

  get props(): Record<string, any> {
    return this._props;
  }

  set props(props: Record<string, any>) {
    this._props = props;
  }

  get attrs(): Record<string, any> {
    return this._attrs;
  }

  set attrs(attrs: Record<string, any>) {
    this._attrs = attrs;
  }

  namespace(): string {
    return "page";
  }

  updateProps(props: Record<string, any>): void {
    this._props = Object.assign({}, this._props, props);
  }

  updateAttrs(attrs: Record<string, any>): void {
    this._attrs = Object.assign({}, this._attrs, attrs);
  }

  toJSON(): any {
    return {
      id: this.id,
      props: this.props,
      attrs: this.attrs,
      blocks: this.blocks.map((it: any) => it.toJSON()),
    };
  }

  protected init(): any {
    return {
      props: {
        background_color: "#fafafa",
        color: "#000000",
        primaryColor: "#e11d48",
        gap: null,
        block: {
          heading_align: "left",
        },
      },
      attrs: {},
    };
  }
}

for (const block of BlockMetas) {
  BlockFactory.getInstance().register(block.type, block.class, "page");
}
